import React from "react";
import UserListItem from "./UserListItem";

export default function UserList({ users }) {
  return (
    <section className="results-section">
      <div className="section-heading">
        <h2>Developer matches</h2>
        <p>{users.length} profile{users.length === 1 ? "" : "s"} found</p>
      </div>
      <div className="card-grid">
        {users &&
          users.map((item, i) => <UserListItem key={item.id || i} user={item} />)}
      </div>
    </section>
  );
}
